import DOMPurify from "dompurify";
import { UpdateTicket } from "../Tickets/UpdateTicket.js";
import "./Messages.css"
import he from "he"

export function sanitize(result){
 return DOMPurify.sanitize(result, {
       ALLOWED_TAGS: ["b", "i", "em", "strong", "u", "a", "br", "img"],
      ALLOWED_ATTR: ["href","style", "target","src", "rel","class","title","data-bs-toggle","data-bs-placement","aria-label",]
  });
}
function linkify(text, attachmentMessage=null) {
  if (!text) return "";
   if(attachmentMessage){
    console.log(text)
    return text;
  }
  let result = text;
 
  const markdownRegex = /\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g;
  result = result.replace(markdownRegex, (_, label, url) => {
    const linkText = label?.trim() ? label : "Click here";
    return `<a href="${he.escape(url)}" target="_blank" rel="noopener noreferrer">${he.escape(linkText)}</a>`;
  });
 
  const urlRegex = /(?<!href=")(https?:\/\/[^\s<]+)/g;
  result = result.replace(urlRegex, (url) => {
    return `<a href="${he.escape(url)}" target="_blank" rel="noopener noreferrer">Click here</a>`;
  });
 
  return sanitize(result)
}
 
 
export function Messages({ msg }) {
  const isUser = msg.from === "user";
 
  if (msg.type === "ui") {
    switch (msg.uiType) {
      case "ticket":
        return <UpdateTicket msg={msg} />;
      default:
        return null;
    }
  }
  
  return (
  <div className="message-wrapper">
    <div
      className="timestamp"
      style={{
        fontSize: "0.75rem",
        color: "#888",
        marginBottom: "4px",
        textAlign: isUser ? "right" : "left",
      }}
    >
      {msg.timestamp}
    </div>

    {((msg.text && msg.text.trim() !== "") || typeof msg.data === "object") && (
      <div className={`message-row ${isUser ? "user-row" : "bot-row"}`}>
        {/* Only show bot avatar for bot messages */}
        {!isUser && (
          <img
            src="/assistant-icon.png"
            alt="Assistant"
            className="chat-avatar bot-avatar"
          />
        )}

        {/* For user messages, render a spacer instead of avatar (optional) */}
        {isUser && <div style={{ fontSize: '0.8rem', color: '#888' }} />}

        <div className={`message ${isUser ? (msg.attachmentMessage ? "": "user-message")  : "bot-message"}`}>
          {msg.type === "text" && msg.text && (
            <div
              dangerouslySetInnerHTML={{
                __html:linkify(msg.text, msg?.attachmentMessage),
              }}
            />
          )}
          {msg.type === "ticket" && (typeof msg.data === "object") && (

              <div>
                Thanks! Please find the details for the selected Ticket Number:&nbsp;
                <a
                  href={he.encode(msg.data.url)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {he.encode(String(msg.data.formattedReference))}
                </a><br/>
                <strong>Description</strong>:{" "}
                {linkify((msg.data.shortDescription))}
              </div>

          )}
          {msg.type === "ui" && <UpdateTicket msg={msg} />}
        </div>
      </div>
    )}
  </div>
);
}